/**
 * FilterBar Component
 * Position and team filters for player list
 */

import type { Position, PlayerFilters } from '@/types';

interface FilterBarProps {
  filters: PlayerFilters;
  onFilterChange: (filters: Partial<PlayerFilters>) => void;
  teams: string[];
}

const positions: { value: Position | 'all'; label: string; color: string }[] = [
  { value: 'all', label: '全部', color: '#a0a0b0' },
  { value: 'TOP', label: '上单', color: '#ff6b6b' },
  { value: 'JUNGLE', label: '打野', color: '#4ecdc4' },
  { value: 'MID', label: '中单', color: '#ffe66d' },
  { value: 'ADC', label: 'ADC', color: '#ff6b9d' },
  { value: 'SUPPORT', label: '辅助', color: '#95e1d3' },
];

export function FilterBar({ filters, onFilterChange, teams }: FilterBarProps) {
  return (
    <div className="space-y-4 mb-8">
      {/* Search Input */}
      <div className="relative">
        <input
          type="text"
          placeholder="搜索选手..."
          value={filters.search}
          onChange={(e) => onFilterChange({ search: e.target.value })}
          className="w-full md:w-80 px-4 py-2.5 bg-surface border border-border rounded-xl text-primary placeholder:text-tertiary focus:outline-none focus:border-secondary transition-colors"
        />
        {filters.search && (
          <button
            onClick={() => onFilterChange({ search: '' })}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-tertiary hover:text-secondary"
          >
            ✕
          </button>
        )}
      </div>

      {/* Position Filters */}
      <div className="flex flex-wrap gap-2">
        {positions.map((pos) => (
          <button
            key={pos.value}
            onClick={() => onFilterChange({ position: pos.value })}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
              filters.position === pos.value
                ? 'text-background'
                : 'bg-surface border border-border text-secondary hover:border-tertiary'
            }`}
            style={
              filters.position === pos.value
                ? { backgroundColor: pos.color }
                : undefined
            }
          >
            {pos.label}
          </button>
        ))}
      </div>

      {/* Team Filter */}
      {teams.length > 0 && (
        <div className="flex items-center gap-3">
          <span className="text-tertiary text-sm">战队:</span>
          <select
            value={filters.team}
            onChange={(e) => onFilterChange({ team: e.target.value })}
            className="px-4 py-2 bg-surface border border-border rounded-xl text-secondary focus:outline-none focus:border-tertiary transition-colors cursor-pointer"
          >
            <option value="all">全部战队</option>
            {teams.map((team) => (
              <option key={team} value={team}>
                {team}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
